import spinner from './loading.svg';
import { cn, cva } from '@thinkalpha/ui-core/utils';
import type { VariantProps } from '@thinkalpha/ui-core/utils';
import React, { useRef } from 'react';

const spinnerVariants = cva('', {
    variants: {
        size: {
            xsmall: 'h-5 w-5',
            small: 'h-6 w-6',
            medium: 'h-12 w-12',
            large: 'h-20 w-20',
            flexible: 'h-full w-full',
        },
        centered: {
            true: 'mx-auto',
            false: '',
        },
    },
    defaultVariants: {
        size: 'medium',
        centered: false,
    },
});

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof spinnerVariants> {
    size?: 'xsmall' | 'small' | 'medium' | 'large' | 'flexible';
    hidden?: boolean;
    centered?: boolean;
}

export const Spinner = ({ size = 'medium', hidden, className, centered = false, ...props }: SpinnerProps) => {
    const container = useRef<HTMLDivElement>(null);

    return (
        <div
            className={cn(className)}
            hidden={hidden}
            data-testid="wait-spinner"
            style={{ colorScheme: 'light' }}
            {...props}
        >
            <div className={spinnerVariants({ size, centered })} ref={container}>
                <object type="image/svg+xml" data={spinner}>
                    <img src={spinner} alt="Loading" />
                </object>
            </div>
        </div>
    );
};

export const SpinnerOverlay = (spinnerProps: SpinnerProps) => {
    return (
        <div className="absolute z-sky-high flex h-full w-full items-center justify-center bg-background">
            <Spinner centered {...spinnerProps} />
        </div>
    );
};
